import React from 'react';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';

import MKTypography from 'components/MKTypography';
import MKButton from 'components/MKButton';

import { commonInputProps, secondaryButtonSx } from '../utils/constants';

function EducationModal({ open, handleClose, form, setForm, onSave, errors }) {
  // Obtenemos fecha actual
  const today = new Date().toISOString().split('T')[0];

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      fullWidth
      maxWidth="md"
      PaperProps={{ sx: { borderRadius: 3, p: 1 } }}
    >
      <DialogTitle sx={{ pb: 0.5 }}>
        <MKTypography variant="h3" color="info" fontWeight="bold">
          Agregar Educación
        </MKTypography>
      </DialogTitle>
      <DialogContent sx={{ pt: 3 }}>
        <Grid container spacing={2.5} sx={{ pt: 2 }}>
          <Grid item xs={12}>
            <TextField
              label="Institución educativa"
              placeholder="P. ej. Universidad de Salamanca"
              value={form.institucion}
              onChange={(e) => setForm((p) => ({ ...p, institucion: e.target.value }))}
              error={!!errors.institucion}
              helperText={errors.institucion}
              {...commonInputProps}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              label="Título"
              placeholder="Grado/licenciatura en Ciencias"
              value={form.titulo}
              onChange={(e) => setForm((p) => ({ ...p, titulo: e.target.value }))}
              error={!!errors.titulo}
              helperText={errors.titulo}
              {...commonInputProps}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              label="Disciplina académica"
              placeholder="P. ej. Empresariales"
              value={form.disciplina}
              onChange={(e) => setForm((p) => ({ ...p, disciplina: e.target.value }))}
              {...commonInputProps}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              type="date"
              label="Fecha de inicio"
              value={form.fechaInicio}
              onChange={(e) => setForm((p) => ({ ...p, fechaInicio: e.target.value }))}
              error={!!errors.fechaInicio}
              helperText={errors.fechaInicio}
              {...commonInputProps}
              inputProps={{ max: today }} // BLOQUEO
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              type="date"
              label="Fecha de finalización"
              value={form.fechaFin}
              onChange={(e) => setForm((p) => ({ ...p, fechaFin: e.target.value }))}
              error={!!errors.fechaFin}
              helperText={errors.fechaFin}
              {...commonInputProps}
              inputProps={{ max: today }} // BLOQUEO
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              label="Descripción"
              value={form.descripcion}
              onChange={(e) => setForm((p) => ({ ...p, descripcion: e.target.value }))}
              multiline
              minRows={4}
              fullWidth
              variant="outlined"
              InputLabelProps={{ shrink: true }}
              sx={{ '& .MuiOutlinedInput-root': { padding: '12px' } }}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions sx={{ p: 3 }}>
        <MKButton variant="contained" size="large" onClick={handleClose} sx={secondaryButtonSx}>
          Atrás
        </MKButton>
        <MKButton variant="contained" color="info" size="large" onClick={onSave}>
          Guardar
        </MKButton>
      </DialogActions>
    </Dialog>
  );
}

export default EducationModal;
